import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const fetchLogisticAreasList = () => {
  return apiActionCreator({
    'endpoint': '/logistic-areas',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_LOGISTIC_AREAS,
      ActionTypes.FETCHED_LOGISTIC_AREAS,
      [
        ActionTypes.FETCHED_LOGISTIC_AREAS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const addNewLogisticArea = (data) => {
  return apiActionCreator({
    'endpoint': '/logistic-areas',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_LOGISTIC_AREAS,
      ActionTypes.ADDED_LOGISTIC_AREAS,
      [
        ActionTypes.ADDED_LOGISTIC_AREAS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });
};

export const updateLogisticArea = (params, data) => {
  return apiActionCreator({
    'endpoint': `/logistic-areas${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_LOGISTIC_AREAS,
      [
        ActionTypes.UPDATED_LOGISTIC_AREAS,
        addMessageBoxInfo('El area se ha actualizado exitosamente.'),
      ],
      [
        ActionTypes.UPDATED_LOGISTIC_AREAS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });
};

export const clearLogisticServices = () => ({
  'type': ActionTypes.CLEAR_LOGISTIC_AREAS,
});
